module.exports = __webpack_public_path__ + "img/tokenBox22.1dd29182.png";